import { Col, Form, Input, InputNumber, Row } from 'antd'
import withSort from '../../../elements/HOC/withSort'
import ProductSelection from '../../../elements/ProductSelection'
import CustomSelect from '../../../elements/Select/CustomSelect'
import OrganisationsSelect from '../../../elements/Select/Organistaions'
import withData from '../../../elements/Select/withData'
import { get } from 'lodash'
import { defaultFormItemLayout, rules, threeFormItemLayout } from '../../../modules/FormItems'
import React from 'react'

import { compose } from 'recompose'

const StateSelect = compose(
  withData({
    data: [
      { key: 'credit', value: 'Credit' },
      { key: 'debit', value: 'Debit' },
    ],
  }),
  withSort,
)(CustomSelect)

function StockForm(props) {
  const { stock } = props
  console.log({ stock })
  const {
    getFieldDecorator,
    setFieldsValue,
    resetFields,
    getFieldValue,
    getFieldsValue,
  } = props.form

  return (
    <Form>
      <Row>
        <Col span={8}>
          <Form.Item {...threeFormItemLayout} label="Name">
            {getFieldDecorator('name', {
              initialValue: get(stock, 'name'),
              rules: rules.input,
            })(<Input placeholder={'Name'} />)}
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item {...threeFormItemLayout} label="Type">
            {getFieldDecorator('type', {
              initialValue: get(stock, 'type'),
              rules: rules.input,
            })(<StateSelect placeholder={'type'} />)}
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item {...threeFormItemLayout} label="Unit">
            {getFieldDecorator('unit', {
              initialValue: get(stock, 'unit'),
              rules: rules.input,
            })(<InputNumber placeholder={'Name'} />)}
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item {...defaultFormItemLayout} label={'Company'}>
            {getFieldDecorator('company._id', {
              initialValue: get(stock, 'company._id'),
              rules: rules.select,
            })(<OrganisationsSelect />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <ProductSelection
          doc={stock}
          {...{
            getFieldDecorator,
            getFieldsValue,
            getFieldValue,
            setFieldsValue,
            resetFields,
            company: getFieldValue('company._id'),
          }}
        />
      </Row>
    </Form>
  )
}

StockForm.propTypes = {}
StockForm.defaultProps = {}

export default Form.create()((StockForm))
